<oiq-layout-page-single
  [title]="'Settings'"
  [breadcrumb]="[{ text: 'Home', route: '/admin', icon: 'home' }, { text: 'Settings', route: '' }]"
  [submenu]="[]">

  <div class="settings-layout">
    <div class="flex flex-col flex-shrink-0 gap-3">
      <nav class="settings-nav">
        <div class="settings-nav-list">
          @for (item of navItems(); track item.route) {
            <a class="settings-nav-item"
              [routerLink]="item.route"
              routerLinkActive="active">
              <img [src]="item.svg" class="nav-svg-icon" alt="" />
              <span>{{ item.label }}</span>
            </a>
          }
        </div>
      </nav>

      @if (isDeveloper() && isApiKeysPage()) {
        <a
          [href]="apiDocsUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="flex items-center gap-2 px-5 py-[9px] text-sm font-medium text-primary hover:underline"
        >
          <img src="/assets/icons/link-icon.svg" alt="" width="20" height="20" />
          API Documentation
        </a>
      }
    </div>

    <div class="settings-content">
      <router-outlet></router-outlet>
    </div>
  </div>

</oiq-layout-page-single>
